import { EDayOfWeek, EScheduleRepetitionType } from '../types';

const DAY_OF_WEEK_ORDER = [
  EDayOfWeek.Monday,
  EDayOfWeek.Tuesday,
  EDayOfWeek.Wednesday,
  EDayOfWeek.Thursday,
  EDayOfWeek.Friday,
  EDayOfWeek.Saturday,
  EDayOfWeek.Sunday,
] as const;

const CRONTAB_DAY_OF_WEEK_TO_DAY_LETTER = {
  [EDayOfWeek.Monday]: 'L',
  [EDayOfWeek.Tuesday]: 'M',
  [EDayOfWeek.Wednesday]: 'X',
  [EDayOfWeek.Thursday]: 'J',
  [EDayOfWeek.Friday]: 'V',
  [EDayOfWeek.Saturday]: 'S',
  [EDayOfWeek.Sunday]: 'D',
};

const REPETITION_TYPE_TO_TIMES_MAX_VALUE: Record<EScheduleRepetitionType, number> = {
  days: 365,
  weeks: 52,
  months: 12,
  minutes: 60,
  hours: 24,
};

export { CRONTAB_DAY_OF_WEEK_TO_DAY_LETTER, DAY_OF_WEEK_ORDER, REPETITION_TYPE_TO_TIMES_MAX_VALUE };
